module.exports = __webpack_public_path__ + "static/media/P1010334.JPG.4ff47c4e.jpg";